import { render, staticRenderFns } from "./AddOrEditOrganization.vue?vue&type=template&id=57830d6e&scoped=true"
import script from "./AddOrEditOrganization.vue?vue&type=script&lang=js"
export * from "./AddOrEditOrganization.vue?vue&type=script&lang=js"
import style0 from "./AddOrEditOrganization.vue?vue&type=style&index=0&id=57830d6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57830d6e",
  null
  
)

export default component.exports